/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import Wrapper from './Wrapper';
import OzComponent from '../lib/OzComponent';
import OzModalButton from './partials/OzModalButton';
import OzTabs from '../lib/OzTabs';
import SimpleEscapeForm from './partials/SimpleEscapeForm';
import LeaderboardWidget from './partials/LeaderboardWidget';

import './ProLeaderboards.css';

import {
  fetchUser,
  listCompanies,
  listEscapes,
  updateEscape,
  addEscape,
} from '../actions';


class EditLeaderboard extends Component {

  state = {};

  componentDidMount() {
    this.props.listEscapes({ room: this.props.roomId }, { local: true, silent: true })
      .then(resp => {
        this.setState({ escapes: resp.items });
      });
  }

  didUpdate() {
    return this.props.listEscapes({ room: this.props.roomId }, { local: true })
      .then(resp => {
        this.setState({ escapes: resp.items, editing: null });
      });
  }

  saveEscape(e, escapeId, values) {
    this.props.updateEscape(escapeId, values.escape)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate();
      });
  }

  verify(escapeId) {
    this.props.updateEscape(escapeId, { verified: true })
      .then(resp => this.didUpdate());
  }

  unverify(escapeId) {
    this.props.updateEscape(escapeId, { verified: false })
      .then(resp => this.didUpdate());
  }

  renderEscapes() {
    let escapes = this.state.escapes;
    if (!escapes) return;
    console.log('widget escapes', escapes);

    escapes.sort((a, b) => {
      let apt = a.prettyTime || '9999:99';
      let bpt = b.prettyTime || '9999:99';
      return apt.localeCompare(bpt);
    });

    let rank = 1;
    let nodes = escapes.map(escape => {
      let r = '';
      if (escape.verified) {
        r = '#' + rank;
        rank++;
      }
      return (
        <div className="escape" key={escape.id}>
          <div className="rank">{r}</div>
          <div className="name">{escape.displayName}</div>
          <div className="time">{escape.didEscape ? escape.prettyTime : 'Did not escape'}</div>
          <div className="controls">
            <OzModalButton
              modalTitle="Edit Escape"
              show={this.state.editing == escape.id}
              onShow={() => this.setState({ editing: escape.id })}
              onHide={() => this.setState({ editing: null })}
              >
              <Button bsSize="small">Edit</Button>

              <SimpleEscapeForm
                values={escape}
                modal={true}
                errors={this.props.errors.addEscape}
                buttonText="Save"
                cancelText="Cancel"
                onSubmit={(e, values) => this.saveEscape(e, escape.id, values)}
                onCancel={() => this.setState({ editing: null })}
              />
            </OzModalButton>{' '}

            <Link to={'/e/' + escape.room.slug + '/' + escape.id}>
              <Button bsSize="small">View</Button>
            </Link>

            {escape.verified && <Button bsSize="small" onClick={() => this.unverify(escape.id)}>Un-Verify</Button>}
            {!escape.verified && <Button bsSize="small" bsStyle="primary" onClick={() => this.verify(escape.id)}><FontAwesome name="check-circle" /> Verify</Button>}
          </div>
        </div>
      );
    });

    return (
      <div className="leaderboard">
        <div className="escapes">
          {nodes}
        </div>
      </div>
    );
  }

  addEscape(e, values) {
    console.log('add escape', values);
    this.props.addEscape(values)
      .then(resp => {
        if (resp.error) return;
        this.didUpdate().then(() => this.setState({ adding: false }));
      });
  }

  render() {
    let room = this.props.room;

    return (
      <div className="EditLeaderboard">
        <div className="header">
          <div className="title">
            Manage <b>{room.name}</b> leaderboard
          </div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Escape"
              show={this.state.adding}
              onShow={() => this.setState({ adding: true })}
              onHide={() => this.setState({ adding: false })}
              >
              <Button>
                Add Escape
              </Button>

              <SimpleEscapeForm
                enterTeam
                values={{ roomId: this.props.roomId }}
                modal={true}
                errors={this.props.errors.escape}
                buttonText="Add"
                cancelText="Cancel"
                onSubmit={(e, values) => this.addEscape(e, values)}
                onCancel={() => this.setState({ adding: false })}
              />
            </OzModalButton>
          </div>
        </div>

        {this.renderEscapes()}
      </div>
    );
  }
}


class ProLeaderboards extends OzComponent {

  static need = [
    ['user', fetchUser],
    ['companies', listCompanies, p => { return [{ mine: 1 }] }],
  ]

  renderRoom(room) {
    return (
      <div className="manage-room-leaderboard">
        <div className="room-name">{room.name}</div>
        <div><Link to={'/pro/rooms/' + room.id + '?tab=leaderboard'}><Button bsStyle="primary">Manage Leaderboard</Button></Link></div>
      </div>
    );
  }

  renderLocation(location) {
    let nodes = location.rooms.map(room => this.renderRoom(room));
    return (
      <div className="manage-location">
        <div className="location-address">{location.address}</div>
        <div>{nodes}</div>
      </div>
    );
  }

  renderLeaderboards() {
    let companies = this.props.companies;
    if (!companies) return;

    let company = companies.items[0];
    let nodes = company.locations.map(location => <div key={location.id}>{this.renderLocation(location)}</div>);
    return <div>{nodes}</div>;
  }

  render() {
    return (
      <Wrapper className="ProLeaderboards" padded pro>
        <div className="pro-header">Leaderboards</div>

        {this.renderLeaderboards()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listEscapes,
    updateEscape,
    addEscape,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProLeaderboards);



/** WEBPACK FOOTER **
 ** ./src/components/ProLeaderboards.js
 **/